module.exports = __webpack_public_path__ + "img/ic-payoneer.db2c5b4f.svg";